import React, { useMemo } from 'react'

import { Button, Icon, Payment } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

const NAVIGATION_SAFETY_TIMEOUT_MS = 1500

function SubscribeButton({ paymentFormPath, onClick: handleClick }) {
  const href = useMemo(() => {
    if (typeof window === 'undefined') return paymentFormPath

    try {
      const url = new URL(paymentFormPath, window.location.origin)
      url.searchParams.set('return_url', window.location.href)
      return url.toString()
    } catch {
      return paymentFormPath
    }
  }, [paymentFormPath])

  const handleNavigate = (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return

    event.preventDefault()

    let navigated = false
    const navigate = () => {
      if (navigated) return
      navigated = true
      window.location.href = href
    }

    if (typeof handleClick === 'function') {
      handleClick(navigate)
      setTimeout(navigate, NAVIGATION_SAFETY_TIMEOUT_MS)
    } else {
      navigate()
    }
  }

  return (
    <Button
      type="primary-warning"
      size="large"
      customClass="pricing-area__actions-button pricing-area__subscribe-button"
      trailIcon={<Icon svgComponent={Payment} />}
      href={href}
      onClick={handleNavigate}
      aria-label="Subscribe and save"
    >
      Subscribe and save
    </Button>
  )
}

SubscribeButton.propTypes = {
  paymentFormPath: string.isRequired,
  onClick: func,
}

export default SubscribeButton
